import MainLayout from "components/MainLayout";
import Metadata from "components/Metadata";
import React from "react";

export default function PrivacyPage() {
  return (
    <MainLayout>
      <Metadata
        title="Privacy Policy | Pipers For Hire"
        description="Read how our privacy policy reflects our commitment to transparency and to your privacy."
        url="https://pipersforhire.com/privacy"
      />
      <h1 className="text-2xl font-bold text-theme-blue">Privacy Policy</h1>

      <div className="prose mt-20 max-w-screen-lg">
        <h2>Introduction</h2>

        <p>
          Pipers For Hire, LLC, a Tennessee limited liability company (“Pipers
          For Hire,” “we,” “us,” or “our”) respect your privacy and are
          committed to protecting it through our compliance with this policy.
        </p>

        <ol>
          <li>This policy applies to information we collect:</li>
          <li>by way of the www.pipersforhire.com website (the “Site”);</li>
          <li>
            by way of all other products or services offered by Pipers For Hire;
          </li>
          <li>
            in email, text, and other electronic messages between you and Pipers
            For Hire; and
          </li>
          <li>
            when you interact with our advertising and applications on
            third-party websites and services, if those applications or
            advertising include links to this policy.
          </li>
        </ol>

        <p>
          The Site and all other products or services offered by Pipers For Hire
          are hereafter referred to collectively as the “Services.”
        </p>

        <ul>
          This policy does not apply to information collected by:
          <li>
            us offline or through any other means, including on any other
            website operated by Company or any third party (including our
            affiliates and subsidiaries); or
          </li>
          <li>
            any third party (including our affiliates and subsidiaries),
            including through any application or content (including advertising)
            that may link to or be accessible from or on the Website.
          </li>
        </ul>

        <p>
          Please read this policy carefully to understand our policies and
          practices regarding your information and how we will treat it. If you
          do not agree with our policies and practices, your choice is not to
          use our Services. By accessing or using our Services, you agree to
          this privacy policy. This policy may change from time to time. Your
          continued use of this Website after we make changes is deemed to be
          acceptance of those changes, so please check the policy periodically
          for any updates or revisions.
        </p>

        <p>Children Under the Age of 13</p>

        <p>
          Our Services are not intended for children under 13 years of age. No
          one under age 13 may provide any information to or on the Services. We
          do not knowingly collect personal information from children under 13.
          If we learn we have collected or received personal information from a
          child under 13, we will delete that information.
        </p>

        <p>Information We Collect About You and How We Collect It</p>

        <ul>
          Types of Information Collected. We collect several types of
          information from and about users of our Services, including
          information:
          <li>
            by which you may be personally identified, such as name, postal
            address, e-mail address, telephone number, or ANY OTHER INFORMATION
            THE SERVICES COLLECT THAT IS DEFINED AS PERSONAL OR PERSONALLY
            IDENTIFIABLE INFORMATION UNDER AN APPLICABLE LAW (collectively,
            “Personal Information”);
          </li>
          <li>
            that is about you but individually does not identify you; and/or
          </li>
          <li>
            about your internet connection, the equipment you use to access our
            Services and usage details.
          </li>
        </ul>

        <ul>
          Sources of Information Collection. We collect such information:
          <li>directly from you when you provide it to us;</li>
          <li>
            automatically as you navigate through the Services (including usage
            details, IP addresses, and information collected through cookies,
            web beacons, and other tracking technologies); and
          </li>
          <li>
            from third parties, for example, our business partners and service
            providers.
          </li>
        </ul>

        <ul>
          Information You Provide to Us. The information we collect on or
          through our Services may include the following information provided to
          us by you:
          <li>
            Information that you provide by filling in forms on our Services.
            This includes information provided at the time of registering to use
            our Services, subscribing to our Services, posting material, or
            requesting further Services. We may also ask you for information
            when you enter a contest or promotion sponsored by us, and when you
            report a problem or complaint relative to our Services.
          </li>
          <li>
            Records and copies of your correspondence (including email
            addresses), if you contact us.
          </li>
          <li>
            Your responses to surveys that we might ask you to complete for
            research purposes.
          </li>
          <li>
            Details of transactions you carry out through our Services and of
            the fulfillment of your orders. You may be required to provide
            financial information before placing an order through our Services.
          </li>
          <li>Your search queries within the Services.</li>
        </ul>

        <p>
          You also may provide information to be published or displayed
          (hereinafter, “posted”) on public areas of the Services, or
          transmitted to other users of the Services or third parties
          (collectively, “User Contributions”). Your User Contributions are
          posted on and transmitted to others at your own risk. Although, please
          be aware that no security measures are perfect or impenetrable.
          Additionally, we cannot control the actions of other users of the
          Services with whom you may choose to share your User Contributions.
          Therefore, we cannot and do not guarantee that your User Contributions
          will not be viewed by unauthorized persons.
        </p>
        <ul>
          Information We Collect Through Automatic Data Collection Technologies.
          As you navigate through and interact with our Services, we may use
          automatic data collection technologies to collect certain information
          about your equipment, browsing actions, and patterns, including:
          <li>
            details of your visits to our Site and other Services, including
            traffic data, location data, logs, and other communication data and
            the resources that you access and use on the Services; and
          </li>
          <li>
            information about your computer and internet connection, including
            your IP address, operating system, and browser type.
          </li>
        </ul>

        <ul>
          The information we collect automatically is statistical data and may
          include Personal Information, or we may maintain it or associate it
          with Personal Information we collect in other ways or receive from
          third parties. It helps us to improve our Services and to deliver a
          better and more personalized service, including by enabling us to:
          <li>estimate our user base size and usage patterns;</li>
          <li>
            store information about your preferences, allowing us to customize
            our Services according to your individual interests;
          </li>
          <li>speed up your searches; and</li>
          <li>recognize you when you return to our Services.</li>
        </ul>

        <ul>
          The technologies we use for such automatic data collection may
          include:
          <li>
            Cookies (or browser cookies). A cookie is a small file placed on the
            hard drive of your computer. You may refuse to accept browser
            cookies by activating the appropriate setting on your browser.
            However, if you select this setting you may be unable to access
            certain parts of our Services. Unless you have adjusted your browser
            setting so that it will refuse cookies, our system will issue
            cookies when you direct your browser to our Services.
          </li>
        </ul>

        <p>
          Web Beacons. Portions of our Services and our emails may contain small
          electronic files known as web beacons (also referred to as clear gifs,
          pixel tags, and single-pixel gifs) that permit the Company, for
          example, to count users who have visited those pages or opened an
          email and for other related website statistics (for example, recording
          the popularity of certain website content and verifying system and
          server integrity).
        </p>

        <h2>How We Use Your Information</h2>

        <ul>
          We use information that we collect about you or that you provide to
          us, including any Personal Information:
          <li>to provide our Services and their contents to you;</li>
          <li>
            to provide you with information, products, or services that you
            request from us;
          </li>
          <li>to fulfill any other purpose for which you provide it;</li>
          <li>
            to provide you with notices about your account/subscription,
            including expiration and renewal notices;
          </li>
          <li>
            to carry out our obligations and enforce our rights arising from any
            contracts entered into between you and us, including for billing and
            collection;
          </li>
          <li>to notify you about changes to our Services;</li>
          <li>
            to allow you to participate in interactive features on our Services;
          </li>
          <li>
            in any other way we may describe when you provide the information;
            or
          </li>
          <li>for any other purpose with your consent.</li>
        </ul>

        <p>
          We may also use your information to contact you about our own and
          third-parties&apos; goods and services that may be of interest to you.
          If you do not want us to use your information in this way, please
          adjust your user preferences in your account profile. For more
          information, see “Choices About How We Use and Disclose Your
          Information” below.
        </p>

        <p>
          We may use the information we have collected from you to enable us to
          display advertisements to our advertisers&apos; target audiences. Even
          though we do not disclose your Personal Information for these purposes
          without your consent, if you click on or otherwise interact with an
          advertisement, the advertiser may assume that you meet its target
          criteria.
        </p>

        <h2>Disclosure of Your Information</h2>

        <p>
          We may disclose aggregated information about our users, and
          information that does not identify any individual, without
          restriction.
        </p>

        <ul>
          We may disclose Personal Information that we collect or you provide as
          described in this privacy policy:
          <li>to our subsidiaries and affiliates;</li>
          <li>
            to contractors, service providers, and other third parties we use to
            support our business;
          </li>
          <li>
            to any buyer or other successor in the event of a merger,
            divestiture, restructuring, reorganization, dissolution, or other
            sale or transfer of some or all of Pipers For Hire&apos;s assets,
            whether as a going concern or as part of bankruptcy, liquidation, or
            similar proceeding, in which Personal Information held by Pipers For
            Hire about our Services users is among the assets transferred;
          </li>
          <li>
            to third parties to market their products or services to you if you
            have not opted out of these disclosures (for more information, see
            “Choices About How We Use and Disclose Your Information” below);
          </li>
          <li>to fulfill the purpose for which you provide it;</li>
          <li>
            for any other purpose disclosed by us when you provide the
            information; or
          </li>
          <li>with your consent.</li>
        </ul>

        <ul>
          We may also disclose your Personal Information:
          <li>
            to comply with any court order, law, or legal process, including to
            respond to any government or regulatory request;
          </li>
          <li>
            to enforce or apply our Terms of Use for Pipers For Hire Services,
            Terms of Use for Trademark Dispute System, and other agreements,
            including for billing and collection purposes;
          </li>
          <li>
            in the process of processing, reviewing, or acting upon any
            notification or complaint we receive alleging infringement or
            violation of someone&apos;s trademark rights, copyright interests,
            or other intellectual property rights; or
          </li>
          <li>
            if we believe disclosure is necessary or appropriate to protect the
            rights, property, or safety of Pipers For Hire, our customers, or
            others.
          </li>
        </ul>

        <p>Choices About How We Use and Disclose Your Information</p>

        <ul>
          We strive to provide you with choices regarding the Personal
          Information you provide to us. We have created mechanisms to provide
          you with the following control over your information:
          <li>
            Tracking Technologies and Advertising. You can set your browser to
            refuse all or some browser cookies, or to alert you when cookies are
            being sent. If you disable or refuse cookies, please note that some
            parts of this site may then be inaccessible or not function
            properly.
          </li>
          <li>
            Promotional Offers from the Company. If you do not wish to have your
            email address/contact information used by the Company to promote our
            own or third parties&apos; products or services, you can opt-out by
            checking the relevant box located on the form on which we collect
            your data or at any other time by logging into the Services and
            adjusting your user preferences in your account profile by checking
            or unchecking the relevant boxes or by sending us an email stating
            your request to contact@pipersforhire.com. If we have sent you a
            promotional email, you may click the unsubscribe link to opt out of
            all future email distributions. This opt out does not apply to
            information provided to Pipers For Hire as a result of a purchase of
            Services, product service experience or other transactions with
            Pipers For Hire.
          </li>
        </ul>

        <h2>Deletion of Your Personal Information</h2>

        <p>
          If you have an account with us, you have the ability to edit or delete
          most of the Personal Information you have shared with us directly from
          your account settings page. If you would like us to delete your
          profile entirely or need help with deleting specific Personal
          Information that we maintain about you, then you can contact us via
          the Site with a deletion request. After verifying your request, we
          will delete the Personal Information we maintain about you from our
          records as of the date of your request and to the fullest extent
          practicable. If we have questions regarding your request, you must
          make an effort to respond to our inquiries. If we do not understand
          your request, we may not be able to comply. Please note that certain
          information may be excepted from your deletion request. For example,
          we may keep your information where necessary to detect and resolve
          issues related to system security and fraud detection. We will also
          keep information needed to provide any Services you have purchased
          through the Site. For example, if you ask us to delete your Personal
          Information, but have paid for a listing through a certain period, we
          will keep the information related to that listing until it expires in
          case you change your mind. Additionally, we cannot control whether
          other users of our Services have stored a copy of Personal Information
          from the profile you created that would allow them to locate and
          contact you even after we have deleted the Personal Information from
          our records.
        </p>

        <h2>Your California Privacy Rights</h2>

        <p>
          California Civil Code Section § 1798.83 permits users of certain of
          our Services that are California residents to request certain
          information regarding our disclosure of Personal Information to third
          parties for their direct marketing purposes. To make such a request,
          please send an email to contact@pipersforhire.com.
        </p>

        <h2>Data Security</h2>

        <p>
          We have implemented measures designed to secure your personal
          information from accidental loss and from unauthorized access, use,
          alteration, and disclosure.
        </p>

        <p>
          The safety and security of your information also depends on you. Where
          we have given you (or where you have chosen) a password for access to
          certain parts of our Services, you are responsible for keeping this
          password confidential. We ask you not to share your password with
          anyone. We urge you to be careful about giving out information in
          public areas of the Services. The information you share in public
          areas may be viewed by any user of the Services. Unfortunately, the
          transmission of information via the internet is not completely secure.
          Although we do our best to protect your personal information, we
          cannot guarantee the security of your personal information transmitted
          to our Services. Any transmission of personal information is at your
          own risk. We are not, and cannot be, responsible for circumvention of
          any privacy settings or security measures contained on the Services.
        </p>

        <h2>Changes to Our Privacy Policy</h2>

        <p>
          It is our policy to post any changes we make to our privacy policy on
          this page. Any changes of this privacy policy will apply
          prospectively, from the date the modifications are made, as designated
          by the “Last Revised” date depicted above. You will be given notice of
          any material changes by: (a) the updating of the “Last Revised” date,
          above, and (b) an email sent to you by us at the address you designate
          by clicking here, in the event you choose to designate an email
          address. If you choose not to designate an email address, you
          expressly agree that, by updating the “Last Revised” date when
          modifications are made, we are providing you with sufficient notice of
          such changes, and that your continued use of the Services subsequent
          to any modifications will constitute acceptance of this privacy policy
          as so changed.
        </p>

        <h2>Contact Information</h2>

        <p>
          To ask questions or comment about this privacy policy and our privacy
          practices, contact us.
        </p>
      </div>
    </MainLayout>
  );
}
